export default __webpack_public_path__ + "static/media/mika-matin.53e1e881.jpg";